import { render, staticRenderFns } from "./ChooseAssembly.vue?vue&type=template&id=4cf958b0"
import script from "./ChooseAssembly.vue?vue&type=script&lang=js"
export * from "./ChooseAssembly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports